<template>
  <Layout>
    <router-view />
  </Layout>
</template>


<script>
import Layout from '@/layout/index.vue'
export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>
<style>
#app{
  min-width: 17.5rem;
}
*{
  margin: 0;
  padding: 0;
}
</style>
